module.exports = __webpack_public_path__ + "img/mir.f6f890ce.svg";